import { FC, ReactNode, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ArrayTransformationHelper } from 'src/helpers/ArrayTransformationHelper';
import { envBoolean } from 'src/helpers/utils';
import { useConnectedAction } from 'src/hooks/use-connected-action';
import { setGeneralConfigs } from 'src/store/configs/actions';
import { RootState } from 'src/types/store-types';
import { I18nContext } from './../components/render-props/I18Props';

const FALLBACK_LANGAUAGE =
  localStorage.getItem('selectedLanguage') ?? (process.env.REACT_APP_FALLBACK_LANGUAGE as string);

type Props = {
  children: ReactNode;
};
export const I18nProvider: FC<Props> = ({ children }) => {
  const { i18n }: Translation = useTranslation();

  const _getGeneralConfigs = useConnectedAction(setGeneralConfigs.req);

  const { generalConfigs } = useSelector((state: RootState) => state.configs);

  const [locale, setLocale] = useState<string>(FALLBACK_LANGAUAGE);
  const [locales, setLocales] = useState<SelectOptionType[]>([]);

  useEffect(() => {
    if (!!generalConfigs?.languages) {
      // remove stored language if it not exist in localStorage and set fallback lang
      const lang = localStorage.getItem('selectedLanguage');
      const exists = generalConfigs?.languages?.some((l: { name: string }) => l.name === lang);
      if ((lang && !exists) || !lang) {
        localStorage.setItem('selectedLanguage', process.env.REACT_APP_FALLBACK_LANGUAGE as string);
      }

      setLocales(
        ArrayTransformationHelper.convertIntoSelectOptionModel(generalConfigs.languages, ['name', 'name', 'icon'])
      );
    }
  }, [generalConfigs]);

  useEffect(() => {
    if (!envBoolean(process.env.REACT_APP_HAS_GENERAL_LOADER as string)) {
      _getGeneralConfigs();
    }

    if (localStorage.getItem('selectedLanguage')) {
      const lang = localStorage.getItem('selectedLanguage');
      i18n.changeLanguage(lang);
    } else {
      i18n.changeLanguage(process.env.REACT_APP_FALLBACK_LANGUAGE as string);
      localStorage.setItem('selectedLanguage', process.env.REACT_APP_FALLBACK_LANGUAGE as string);
    }
  }, []);

  return (
    <I18nContext.Provider
      value={{
        locale,
        setLocale,
        setLocales,
        locales,
      }}
    >
      {children}
    </I18nContext.Provider>
  );
};
